import { Box, Typography, useTheme } from '@mui/material';
import { useContext } from 'react';

import { LocaleContext } from '@/Contexts/LocaleContext';

type CharacterCountProps = {
  text?: string | null;
  max: number;
  visible?: boolean;
};

export default function CharacterCount({ text = '', max, visible = true }: CharacterCountProps) {
  const theme = useTheme();
  const { translatedText } = useContext(LocaleContext);
  const safeText = typeof text === 'string' ? text : '';
  const remaining = max - safeText.length;

  if (!visible) return null;

  return (
    <Box
      sx={{
        position: 'relative',
        top: '2px',
      }}
    >
      <Box
        sx={{
          width: '250px',
          position: 'absolute',
          right: '5px',
          textAlign: 'right',
        }}
      >
        <Typography
          variant='subtitle3'
          color={remaining === 0 ? theme.palette.error.main : theme.palette.taiga.main}
        >
          {translatedText.common.characterCountRemaining(remaining, max)}
        </Typography>
      </Box>
    </Box>
  );
}
